<template>
  <footer class="h-12 xl:h-24 flex flex-col items-center justify-center w-full">
    <p class="font-bold text-sm">
      Made by
      <a
        class="text-cyan-900 dark:text-cyan-400 pb-1 border-b border-current"
        href="https://arturoalviar.com/"
        target="_blank"
        rel="noopener"
      >
        Arturo Alviar</a
      >
    </p>
  </footer>
</template>
